<template>
<div>
  <PageTitle :route="$route">
    <template slot="action-button">
      <ActionButton
        icon="fa-plus"
        v-on:click="onClickButton"
      />
    </template>
  </PageTitle>

  <PageRowWrapper>
    <div class="col-sm-12">
      <OsList />
    </div>
  </PageRowWrapper>
</div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ActionButton from '@/components/button/ActionButton'
import OsList from '@/components/os/OsList'

export default {
  name: 'Os',
  components: {
    PageTitle,
    ActionButton,
    PageRowWrapper,
    OsList
  },
  methods: {
    onClickButton (e) {
      this.$router.push({ name: 'addos' })
    }
  }
}
</script>
